export default "__VITE_ASSET__vgpx_hqZ__"